import Vue from 'www/vue_components'
import { MOUNT_SELECTOR, DATA_PDF_COUPON, DATA_PDF_PARTICIPATION } from 'www/vue_components/desktop/Club/components/dependencies/ClubDesktopInfoModal/constants'
import ClubDesktopInfoModal from 'www/vue_components/desktop/Club/components/dependencies/ClubDesktopInfoModal/ClubDesktopInfoModal.vue'

const mountNode = document.querySelector(MOUNT_SELECTOR)

if (mountNode) {
  const dataCouponPDF = mountNode.getAttribute(DATA_PDF_COUPON)
  const dataParticipationPDF = mountNode.getAttribute(DATA_PDF_PARTICIPATION)

  if (dataCouponPDF && dataParticipationPDF) {
    new Vue({
      el: mountNode,
      render: h => h(ClubDesktopInfoModal, {
        props: {
          pdfData: {
            coupon: dataCouponPDF,
            participation: dataParticipationPDF,
          },
        },
      }),
    })
  }
}
